import { useEffect, useMemo, useState } from "react";
import agent from "../api/agent";
import { getISODate } from "../helpers/dateHelpers";

export type City = string;
type DateRange = { start: Date; end: Date } | null | undefined;

const useExcursionCities = (dateRange?: DateRange) => {
  const [cities, setCities] = useState<City[]>([]);
  const dateFrom = dateRange?.start ? getISODate(dateRange.start) : undefined;
  const dateTo = dateRange?.end ? getISODate(dateRange.end) : undefined;

  useEffect(() => {
    agent.ExcursionCities.list(dateRange ? { dateFrom, dateTo } : undefined).then(setCities);
  }, [dateFrom, dateTo]); // eslint-disable-line react-hooks/exhaustive-deps

  return useMemo(
    () => ({
      cities,
      cityOptions: cities.map((city) => ({ key: city, value: city, text: city })),
    }),
    [cities]
  );
};

export default useExcursionCities;
